import styled from "styled-components";

export const HelpContentBaseWrapper = styled.div<{ $theme?: string }>`
  width: 100%;
  .fui-AccordionPanel {
    padding: 0px 8px 16px 8px;
    .fui-Dropdown {
      width: 100%;
    }
  }
  .wapper-btn {
    display: flex;
    justify-content: flex-end;
    border-top: 1px solid #bababa;
    /* padding-bottom: 10px; */
    .rf-settings-button {
      margin-top: 10px;
      padding: 4px 12x !important;
      background-color: #106ebe;
      color: #fff;
    }
  }
`;

export const LocationContentRowBaseWrapper = styled.div<{ $theme?: string }>`
  padding: 0px;
  border-top: 1px solid #bababa;
`;
